export const tracingRouteStates = {
  jaeger: 'dashboard.jaeger',
  samplingRules: 'dashboard.tools.tracing-sampling-rules',
  yamlConfig: 'dashboard.settings.tracing-yaml-configuration',
  yamlConfigLocalhost: 'dashboard.settings.tracing-yaml-configuration.localhost',
  yamlConfigLocalhostDockerAndK8s: 'dashboard.settings.tracing-yaml-configuration.dockerAndk8s',
};
